var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border overflow-auto rounded-lg",class:{
    'border-ds-outline-primary': _vm.hasBorder,
    'border-none': !_vm.hasBorder,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }